<template lang="html">
  <div v-if="calculatorsLoaded">
    <v-container
      grid-list-lg
      py-8
      fluid
    >
      <v-layout wrap>
        <v-flex v-bind="_pageLayout">
          <v-layout wrap>
            <v-flex
              xs12
              mb-2
            >
              <v-btn
                to="/"
                text
                replace
                color="grey"
              >
                <v-layout align-center>
                  <v-icon left>
                    arrow_back
                  </v-icon>Home
                </v-layout>
              </v-btn>
            </v-flex>
            <v-flex
              xs12
              mb-4
              class="display-2 font-weight-light"
            >
              {{ calculator.name }}
            </v-flex>
            <v-flex
              v-show="hasBodyText"
              xs12
              my-4
            >
              <v-divider />
            </v-flex>
            <v-flex
              v-show="hasBodyText"
              xs12
              class="si-wiki-content"
              style="max-width: 700px; "
              v-html="body"
            />
          </v-layout>
          <v-layout
            v-show="!_isPreRender"
            wrap
            mb-8
          >
            <v-flex
              xs12
              my-4
            >
              <v-divider />
            </v-flex>
            <v-flex
              xs12
              class="display-1 font-weight-light"
            >
              Get started
            </v-flex>

            <v-flex
              v-for="calculator in variants"
              :key="`${calculator.cid}_${calculator.vid}`"
              xs12
              lg6
            >
              <SiProductCard
                :product="calculator"
                hide-info
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import renderReady from '@/mixins/render-ready'
import 'lazysizes'


export default {
  mixins: [ helpers, renderReady ],
  metaInfo () {
    let title = `${this.calculator.name || ''} Calculator`
    let description = this.wiki.description || ''
    let url = `${process.env.VUE_APP_BASE_URL}/about/calculator/${this.calculatorId}`
    return {
      changed: () => {
        if (this.calculatorsLoaded) this.metaSet = true
      },
      title,
      meta: [
        { name: 'description', content: description },
        { name: 'url', content: url },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: url },
        { property: 'twitter:title', content: title },
        { property: 'twitter:description', content: description },
        { property: 'twitter:url', content: url },

      ]
    }
  },
  data () {
    return { 
      wiki: {},
      loading: true,
      renderWhen: { loading: false, metaSet: true },
      metaSet: false
    }
  },
  computed: {
    ...mapGetters(['_pageLayout', '_calculators']),
    calculatorId () {
      let { $route: { params: { calculator } = {} } = {} } = this
      return calculator
    },
    calculator () {
      let { _calculators, calculatorId } = this
      return _calculators[calculatorId] || {}
    },
    calculatorsLoaded () {
      let { _calculators, calculatorId } = this
      return Boolean(_calculators[calculatorId])
    },
    variants () {
      return this._sortObject(this.calculator.variants)
        .map(v => 
          ({ ...v, ...{ cid: this.calculatorId, vid: v.id, image: this.calculator.image }})
        )
    },
    body () {
      return this.wiki.body
    },
    hasBodyText () {
      var span = document.createElement('span')
      span.innerHTML = this.body
      return Boolean(span.textContent || span.innerText)
    },
  },
  beforeMount () {
    rtdb.ref(`calculators/${this.calculatorId}/wiki`).once('value').then(s => {
      let wiki = s.val() || {}
      let el = document.createElement( 'html' );
      el.innerHTML = wiki.body || ''

      let imgs = el.getElementsByTagName('img');

      for(let i = 0; i < imgs.length; i++){
        let image = imgs[i]
        image.src = image.dataset.thumbSrc || image.src
        image.classList = 'lazyload'
      }
      let body = el.innerHTML
      this.wiki = {...wiki, body}
      this.$nextTick(() => {
        this.loading = false
      })
    })
  }
}
</script>

<style lang="scss" >
.si-wiki-content{
  h1, h2, h3, h4 {
    font-weight: 300;  
  }
  img { 
    max-width: 100%;
  }
}
</style>
